import { ADD_A_JOB_STEPS_DESKTOP } from '../CreateJob-constants';

const ContainerComponent = ({ children }) => {
  const steps = Object.values(ADD_A_JOB_STEPS_DESKTOP);

  return children({ steps });
};

ContainerComponent.displayName = 'CreateJob-Desktop-container';

export default ContainerComponent;
